import { Grid } from '@mui/material';
import { MapEnum } from 'common/defines/constants';
import { SelectDateAnalytics } from 'components/Common/SelectDateAnalytics';
import { useCallback, useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { clearCo2SequestrationAnalytics } from 'store/slices/map-view/co2SequestrationAnalytics';
import { clearGapAnalytics } from 'store/slices/map-view/gapAnalytics';
import { clearPlantHealthOilPailmAnalytics } from 'store/slices/map-view/plantHealthOilPailmAnalytics';
import { changeDataPointClicked } from 'store/slices/map-view/standCountAnalytics';
import { clearTreeHeightAnalytics } from 'store/slices/map-view/treeHeightAnalytics';
import { clearTreeTiltFallenAnalytics } from 'store/slices/map-view/treeTiltFallenAnalytics';
import { clearData, mapViewSelector, selectRasterLayer } from 'store/slices/mapViewSlice';
import { clearChlorophyllAnalytics } from '../../../../store/slices/map-view/chlorophyllAnalytics';
import { clearCircumferenceAnalytics } from '../../../../store/slices/map-view/circumferenceAnalytics';
import { clearCrownAreaAnalytics } from '../../../../store/slices/map-view/crownAreaAnalytics';
import { clearPlantStressAnalytics } from '../../../../store/slices/map-view/plantStressAnalytics';
import { clearVigorAnalytics } from '../../../../store/slices/map-view/vigorAnalytics';
import { clearWaterUptakeAnalytics } from '../../../../store/slices/map-view/waterUptakeAnalytics';
import { clearWeedInvasionAnalytics } from '../../../../store/slices/map-view/weedInvasionAnalytics';
import { useAnalyticTabStyle } from '../../MapViewStyle';
import AnalyticTabContent from './AnalyticTabContent';
import TemporalButton from './TemporalButton';
import TemporalModal from './TemporalModal';

export const AnalyticsTab = () => {
  const [isShowTemporalModal, setIsShowTemporalModal] = useState<boolean>(false);

  const classes = useAnalyticTabStyle();
  const dispatch = useAppDispatch();
  const { dateAnalyticSelected, levelId } = useAppSelector(mapViewSelector);

  const clearDataAnalytics = useCallback(() => {
    dispatch(clearCircumferenceAnalytics());
    dispatch(clearVigorAnalytics());
    dispatch(clearPlantStressAnalytics());
    dispatch(clearCrownAreaAnalytics());
    dispatch(clearWaterUptakeAnalytics());
    dispatch(clearChlorophyllAnalytics());
    dispatch(clearGapAnalytics());
    dispatch(clearTreeTiltFallenAnalytics());
    dispatch(clearPlantHealthOilPailmAnalytics());
    dispatch(clearWeedInvasionAnalytics());
    dispatch(clearTreeHeightAnalytics());
    dispatch(clearCo2SequestrationAnalytics());
    dispatch(clearData());
    dispatch(changeDataPointClicked(undefined));
    dispatch(selectRasterLayer([]));
  }, [dispatch]);

  // clear all data when change date
  useEffect(() => {
    clearDataAnalytics();
  }, [clearDataAnalytics, dateAnalyticSelected]);

  return (
    <Grid container className={classes.tabContainer} direction="column" width="100%">
      {levelId && (
        <Grid container sx={{ mb: '20px' }}>
          <Grid item xs={8}>
            <SelectDateAnalytics levelId={levelId} />
          </Grid>
          <Grid
            item
            xs={4}
            sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row', justifyContent: 'flex-end', pr: '4px' }}>
            <TemporalButton setIsShowTemporalModal={setIsShowTemporalModal} mode={MapEnum.MAP_VIEW} />
          </Grid>
        </Grid>
      )}
      {isShowTemporalModal && (
        <TemporalModal
          isShow={isShowTemporalModal}
          mode={MapEnum.MAP_VIEW}
          handleClose={() => setIsShowTemporalModal(false)}
        />
      )}

      <AnalyticTabContent />
    </Grid>
  );
};
